import * as React from 'react';
import { styled } from "@mui/material/styles";

import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import Leaflet from 'leaflet';

Leaflet.Marker.prototype.options.icon = Leaflet.icon({
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    iconSize: [24,36],
    iconAnchor: [12,36]
});

const mapHeight = 600;

const StyledDivMap = styled("div")(() => ({
    display: "inline-block",
    fontFamily: "'Sen', sans-serif",
    height: mapHeight,
    width: "100%",
    float: "right"
  }));
  

class MapOverview extends React.Component<any, any> {

    render() { 

        if (this.props.isLoaded && this.props.nftrees.length > 0) {
            return <StyledDivMap>
                        <MapContainer center={[this.props.nftrees[0].metadata.latitude, this.props.nftrees[0].metadata.longitude]} zoom={20} zoomControl={true} scrollWheelZoom={true} style={{ height: mapHeight, width: '100%' }} attributionControl={true} dragging={true} >
                                <TileLayer
                                    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                                    maxNativeZoom={18}
                                    maxZoom={21}
                                    attribution='Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
                                />
                                {this.props.nftrees.map((n, index) => {
                                    return (
                                        <Marker position={[n.metadata.latitude, n.metadata.longitude]} key={index}>
                                            <Popup>
                                            {n.metadata.description}
                                            </Popup>
                                        </Marker>
                                    )
                                })}
                                
                            </MapContainer>
                    </StyledDivMap>
        }
    }
}

export default MapOverview